import { Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Debugger } from './components/debugger/debugger';
import { WhStateStore } from './shared/store/state.store';
import { UpdateService } from './shared/services/update.service';
import { BottomsheetSvc } from './shared/services/bottomsheet-svc';
import { Backdrop } from './components/ui/backdrop/backdrop';
import { environment } from 'src/environments/environment';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'wh-root',
  imports: [
    RouterOutlet,
    Debugger,
    Backdrop,
    TranslatePipe,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  private stateStore = inject(WhStateStore);
  private updateSvc = inject(UpdateService);
  private bottomsheetSvc = inject(BottomsheetSvc);

  isMobile = this.stateStore.isMobileScreen;
  isPwa = this.stateStore.isPwa;
  backdropActive = this.stateStore.backdropActive;
  updateOverlayVisible = this.updateSvc.overlayVisible;
  updateOverlayTitleKey = this.updateSvc.overlayTitleKey;
  updateOverlayTextKey = this.updateSvc.overlayTextKey;

  isDebugNotchVisible = computed(() => environment.showPwaFrameDebugger && this.isPwa());

  onBackdropClick() {
    const handled = this.bottomsheetSvc.closeIfOpened();
    if (!handled) this.stateStore.hideBackdrop();
  }
}
